// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tw_V","clinicsSelect":"styles_clinicsSelect__1OhnC"};